import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";

import { useSidebar } from "../../App";

export default function TestAIEndpoint() {
  const { t } = useTranslation("help");
  const { sidebarCollapsed } = useSidebar();

  return (
    <div className="theme-whbl">
      {/* Internal CSS */}
      <style>
        {`
          .dark-guide-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
            font-family: "Segoe UI", Arial, sans-serif;
            font-size: 14px;
            color: #e5e7eb;
            background: #111827;
            border: 1px solid #374151;
          }

          .dark-guide-table thead th {
            background: #1E293B;
            color: #fff;
            font-weight: 700;
            text-align: left;
            padding: 12px 14px;
            border: 1px solid #4b5563;
            vertical-align: middle;
          }

          .dark-guide-table tbody td {
            background: #1E293B;
            color: #fff;
            padding: 12px 14px;
            border: 1px solid #374151;
            vertical-align: top;
            line-height: 1.55;
          }

          .dark-guide-table th:nth-child(1),
          .dark-guide-table td:nth-child(1) {
            width: 23%;
          }

          .dark-guide-table th:nth-child(2),
          .dark-guide-table td:nth-child(2) {
            width: 30%;
          }

          .dark-guide-table th:nth-child(3),
          .dark-guide-table td:nth-child(3) {
            width: 47%;
          }

          @media (max-width: 768px) {
            .dark-guide-table {
              min-width: 750px;
            }
          }

          .help-row {
            display: block;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          .help-row p {
            width: 100%;
            max-width: 100%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }

          .help-row img {
            width: 100%;
            max-width: 650px;
            border-radius: 6px;
            padding: 10px;
            transition: transform 0.8s ease;
            margin: 10px 0;
          }

          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">
          {/* Main Content */}
          <main
            style={{
              width: "97%",
              overflowX: "auto",
            }}
          >
            <div className="dashboard">
              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t("testAIEndpoint.title")}
                </h1>
              </div>

              {/* Content */}
              <div
                style={{
                  backgroundColor: "#10172a",
                  borderRadius: "6px",
                  marginTop: "15px",
                  overflow: "hidden",
                }}
              >
                {/* Step 1 */}
                <div className="help-row">
                  <p>{t("testAIEndpoint.intro.description")}</p>
                </div>

                {/* Step 2 */}
                <div className="help-row">
                  <img
                    src={t("testAIEndpoint.section.image")}
                    alt={t("testAIEndpoint.section.imageAlt")}
                  />
                  <br/> <br/>

<img
                    src={t("testAIEndpoint.section.image2")}
                    alt={t("testAIEndpoint.section.imageAlt")}
                  />

 <br/> <br/>
                  <img
                    src={t("testAIEndpoint.section.image3")}
                    alt={t("testAIEndpoint.section.imageAlt")}
                  />

 <br/> <br/>
                  <img
                    src={t("testAIEndpoint.section.image4")}
                    alt={t("testAIEndpoint.section.imageAlt")}
                  />




                  <table className="dark-guide-table">
                    <thead>
                      <tr>
                        <th>{t("testAIEndpoint.section.table.headers.field")}</th>
                        <th>{t("testAIEndpoint.section.table.headers.purpose")}</th>
                        <th>{t("testAIEndpoint.section.table.headers.detail")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>{t("testAIEndpoint.section.table.rows.url.field")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.url.purpose")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.url.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("testAIEndpoint.section.table.rows.inputScript.field")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.inputScript.purpose")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.inputScript.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("testAIEndpoint.section.table.rows.outputScript.field")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.outputScript.purpose")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.outputScript.detail")}</td>
                      </tr>

                      <tr>
                        <td>{t("testAIEndpoint.section.table.rows.jsons.field")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.jsons.purpose")}</td>
                        <td>{t("testAIEndpoint.section.table.rows.jsons.detail")}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}